import { Helpers } from 'application/Shared/Helpers';
import { UserApp } from 'application/Shared/types/userApp';

import { ColumnFilter } from '../Table/types';
import { sourcesFilter } from './SourcesFilter';

const { defaultOptions } = sourcesFilter;

export const userAppSourcesFilter: ColumnFilter<UserApp> = {
    clientSideFiltering: true,
    defaultOptions,
    filterFn: (row, filterValue) => {
        const filterValueArray = Array.isArray(filterValue)
            ? filterValue
            : [filterValue];

        if (filterValue.length === 0) return true;
        const sources = Helpers.getSourcesWithActivity(row);
        return filterValueArray.some((source) => sources[source]);
    }
};
